module.exports = __webpack_public_path__ + "b04b088f0dc1c870b68c4b222e464582.pdf";